<div class="video-call-modal">
  <portal-video-call
    (invitePartnerInCall)="invitePartnerInCall($event)"
    (unInvitePartnerInCall)="unInvitePartnerInCall($event)"
    [isPartnerInvited]="isPartnerInvited"
    [videoCall]="videoCall"
  ></portal-video-call>
</div>
